module.exports = __webpack_public_path__ + "img/preloader2.074afa0c.gif";